import type { FC } from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { Router } from "./core/router";
import { StoreProvider } from "./core/store";
import { SnackbarProvider } from "notistack";
import { ReportComplete, Nps } from "./components";
import { ThemeProvider } from "./core/theme";

declare module "notistack" {
  interface VariantOverrides {
    reportComplete: true;
  }
}

export const App: FC = () => {
  return (
    <ThemeProvider>
      <SnackbarProvider
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        Components={{ reportComplete: ReportComplete }}
      >
        <StoreProvider>
          <BrowserRouter>
            <Router />
            <Nps position="bottom-right" />
          </BrowserRouter>
        </StoreProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
};
